import * as React from 'react';
import { TMapMedia } from '@cian/frontend-newbuilding-map-component';

import { ICoordinates } from '../../../types/geo';

export function useMapMedia(pinCoordinates: ICoordinates, zoom: number) {
  return React.useMemo<TMapMedia>(
    () => [
      {
        minWidth: -Infinity,
        maxWidth: Infinity,
        options: {
          center: pinCoordinates,
          styles: { width: '100%', height: '100%' },
          animationDuration: 300,
          defaultZoom: zoom,
        },
      },
    ],
    [pinCoordinates, zoom],
  );
}
